export default __webpack_public_path__ + "static/media/logotype-on-light-customer.b625515c.svg";